import styled from 'styled-components';

interface IProps {
    height?: number;
    width?: number;
    className?: string;
}

const Seperator = ({ height, className, width }: IProps) => {
    return <Margin height={height} width={width} className={className} />;
};

const Margin = styled.div<{ height?: number; width?: number }>`
    height: ${({ height }) => height}px;
    width: ${({ width }) => width}px;
`;

export default Seperator;
